import React from "react";
import welcomebgb from "../../Components/assets/images/welcome-bg.png";

function WelcomeCard() {
  return (
    <div
      className="welcome-card user-welcome bg"
      style={{ backgroundImage: `url(${welcomebgb})` }}
    >
      <h2 className="fz-32  text-white">Welcome back, Donna! </h2>
      <div className="fz-22 fw-regular text-white">
        {" "}
        Here is what&apos;s going on today
      </div>
    </div>
  );
}

export default WelcomeCard;
